// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientConsents_root__3VVWq","consentsList":"PatientConsents_consentsList__23AKZ","consentsListEmpty":"PatientConsents_consentsListEmpty__3DEvj"};